/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'

/**
 * 防抖Hook
 * @param {any} value
 * @param {number} [delay]
 */
export const useDebounce = (value: any, delay: number = 500) => {
    const [debounceValue, setDebounceValue] = useState(value)
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebounceValue(value)
        }, delay)
        return () => {
            clearTimeout(timer)
        }
    }, [value])
    return debounceValue
}
